module.exports = __webpack_public_path__ + "img/masspredict_by_you.22118984.png";